module.exports = __webpack_public_path__ + "img/10.3.f57b613e.png";